module.exports = __webpack_public_path__ + "static/media/qscript_logo.46d9ea84.png";